export default __webpack_public_path__ + "static/media/arrow-left.f5ce153f.svg";